import { useMutation } from '@tanstack/react-query';

import { handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postRequestRequiredApplicationDocs } from '../../requests/postRequestRequiredApplicationDocs';

export const useRequestRequiredApplicationDocs = (definitionName: string) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: requestRequiredDocs, ...rest } = useMutation({
    mutationFn: (uuid: string) =>
      postRequestRequiredApplicationDocs(constructPost, uuid, definitionName),
    onSuccess: () => handleSuccess('Success'),
  });

  return { requestRequiredDocs, ...rest };
};
